<template>
  <div class="wrapper">
    <button
      @click="$emit('click')"
      :class="{'round-btn_small': small}"
      class="round-btn"
      v-bind="$attrs"
    >
      <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    small: Boolean,
  },
};
</script>


<style lang="scss" scoped>
.round-btn {
  @include removeBtnDefaults;
  border: 2px solid $red-color3;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  &_small {
    min-width: 28px;
    width: 28px;
    height: 28px;
    .icon-base {
      transform: scale(0.9);
    }
  }
  .icon-base,
  svg {
    margin: auto;
    .btn_got-it_round & {
      margin-top: 1px;
    }
  }
  &[disabled] {
    border-color: $grey-color2;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/uikit/RoundBtn.vue